import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "error", "warning", "id", "labelFeedbackStateColor", "labelFeedbackStateIconStyle", "viewStyle", "textStyle", "styleSheet"];
import React from 'react';
import omitProps from '@hocs/omit-props';
import { compose } from 'recompose';
import { Motion, spring } from '@bubble-ui/primitive-motion';
import Text from '@bubble-ui/primitive-text';
import View from '@bubble-ui/primitive-view';
import FeedbackStateIconError from '@bubble-ui/icon-feedback-state-error';
import FeedbackStateIconErrorWrapper from '@bubble-ui/icon-feedback-state-error-wrapper';
import FeedbackStateIconWarning from '@bubble-ui/icon-feedback-state-warning';
import FeedbackStateIconWarningWrapper from '@bubble-ui/icon-feedback-state-warning-wrapper';
import wrapOverridableComponent from '@bubble-ui/hoc-wrap-overridable-component';
import calculateLabelMotion from './calculateLabelMotion';

var getDefaultStyleSheet = function getDefaultStyleSheet(_ref) {
  var big = _ref.big,
      hasValue = _ref.hasValue,
      focused = _ref.focused;
  return {
    motionStyle: calculateLabelMotion(big, hasValue, focused)
  };
};

var Label = function Label(_ref2) {
  var children = _ref2.children,
      error = _ref2.error,
      warning = _ref2.warning,
      id = _ref2.id,
      labelFeedbackStateColor = _ref2.labelFeedbackStateColor,
      labelFeedbackStateIconStyle = _ref2.labelFeedbackStateIconStyle,
      viewStyle = _ref2.viewStyle,
      textStyle = _ref2.textStyle,
      styleSheet = _ref2.styleSheet,
      props = _objectWithoutProperties(_ref2, _excluded);

  var _styleSheet$motionSty = styleSheet.motionStyle,
      marginTop = _styleSheet$motionSty.marginTop,
      fontSize = _styleSheet$motionSty.fontSize;
  return /*#__PURE__*/React.createElement(Motion, {
    style: {
      marginTop: spring(marginTop),
      fontSize: spring(fontSize)
    }
  }, function (_ref3) {
    var marginTop = _ref3.marginTop,
        fontSize = _ref3.fontSize;
    return /*#__PURE__*/React.createElement(View, _extends({
      id: id,
      style: viewStyle(marginTop)
    }, props), error && /*#__PURE__*/React.createElement(View, {
      style: labelFeedbackStateIconStyle
    }, /*#__PURE__*/React.createElement(FeedbackStateIconErrorWrapper, {
      color: labelFeedbackStateColor
    }), /*#__PURE__*/React.createElement(View, {
      style: {
        position: 'absolute',
        top: 0,
        left: 0
      }
    }, /*#__PURE__*/React.createElement(FeedbackStateIconError, null))), warning && /*#__PURE__*/React.createElement(View, {
      style: labelFeedbackStateIconStyle
    }, /*#__PURE__*/React.createElement(FeedbackStateIconWarningWrapper, {
      color: labelFeedbackStateColor
    }), /*#__PURE__*/React.createElement(View, {
      style: {
        position: 'absolute',
        top: 0,
        left: 0
      }
    }, /*#__PURE__*/React.createElement(FeedbackStateIconWarning, null))), /*#__PURE__*/React.createElement(Text, {
      style: textStyle(fontSize),
      numberOfLines: 1
    }, children));
  });
};

export default compose(wrapOverridableComponent('AtomLabel', getDefaultStyleSheet), omitProps('big', 'focused', 'hasValue'))(Label);
//# sourceMappingURL=index.js.map